import { Check, Play } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import SectionContainer from "@/components/common/SectionContainer";
export default function YurtAmenities() {
  const amenities = ["Climate Control (AC/Heat)", "Detached Private Bathroom", "Linens", "Mini Refrigerator", "Keurig Coffee Maker", "Private Lakefront Fire Pit", "Outdoor Lounge Seating"];
  return <section id="yurtamenities" className="bg-background py-16 md:py-24">
      <SectionContainer>
        <div className="max-w-5xl">
          {/* Paragraphs */}
          <div className="space-y-6 mb-12">
            <p className="text-base md:text-lg font-sans text-foreground/80 leading-relaxed">
              Have you been wanting to set out on a new adventure? Intrigued by the idea of camping, but without leaving behind the allure of luxury? Seeking that getaway to a remote lakefront private experience? This is the place!
            </p>
            <p className="text-base md:text-lg font-sans text-foreground/80 leading-relaxed">
              Glamping is all the rage these days, and Paradise Cove has brought it here for you! Tucked away on a private peninsula right on Lake Grapevine, you can experience the best of camping, with the glamour of a luxury hideaway.
            </p>
            <p className="text-base md:text-lg font-sans text-foreground/80 leading-relaxed">
              This luxurious Yurt (you're right, it is a funny name) is located on the border between Grapevine and Southlake, on the shores of Lake Grapevine. Spend your evening sitting by your own private fire pit – right by the lake! Roast marshmallows, make smores, or just watch the sparks flutter into the skies.
            </p>
          </div>

          <div className="mb-16">
            <Button asChild size="lg" className="w-full md:w-auto font-sans tracking-wider uppercase px-12 h-14 text-base">
              
            </Button>
          </div>

          {/* Amenities Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-2 border border-border shadow-sm mb-16">
            {/* Left box */}
            <div className="bg-primary text-primary-foreground p-8 md:p-12 lg:p-16 flex flex-col justify-center">
              <h2 className="font-default text-2xl md:text-3xl lg:text-4xl font-bold uppercase tracking-wider mb-8">
                Yurt Amenities Include:
              </h2>
              <ul className="space-y-5">
                {amenities.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                    <Check className="w-5 h-5 text-primary-foreground/80 shrink-0 mt-1" />
                    <span className="text-base md:text-lg font-sans">{item}</span>
                  </li>)}
              </ul>
            </div>

            {/* Right image */}
            <div className="relative min-h-[300px] md:min-h-[400px] lg:min-h-auto group cursor-pointer overflow-hidden">
              <img data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_interior_video_preview.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715425/img/yurt_interior_video_preview.png-wvc-sizes" alt="Yurt Interior Preview" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" src="https://paradisecovetx.com/wp-content/uploads/2026/09/glamping-at-the-cove-lakeview.avif" />
              <div className="absolute inset-0 bg-black/20 transition-colors duration-300 group-hover:bg-black/30 flex items-center justify-center">
                
              </div>
              <div className="absolute bottom-6 left-6 right-6 md:bottom-8 md:left-8 md:right-8">
                <p className="text-white font-default tracking-[0.2em] text-xs md:text-sm uppercase font-semibold drop-shadow-md">
                  Live Lake Grapevine
                </p>
              </div>
            </div>
          </div>

          {/* Contact details */}
          <div className="space-y-2">
            <p className="font-sans text-foreground/80 text-sm md:text-base">Contact us for any questions or concerns.</p>
            <p className="font-sans font-semibold text-base md:text-lg">
              <Link href="tel:8173291668" className="hover:underline text-foreground">CALL NOW: (817) 329-1668</Link>
            </p>
            <p className="font-sans font-semibold text-base md:text-lg">
              <Link to="mailto:info@paradisecovetx.com" className="hover:underline text-foreground">info@paradisecovetx.com</Link>
            </p>
          </div>
        </div>
      </SectionContainer>
    </section>;
}